import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

// Before anything renders, so translated screens have their strings.
import './i18n';

import { Route, Routes } from 'react-router';

import { BrowserRouter, Navigate } from "react-router-dom";

import AuthProvider from '@auth/AuthProvider'
import RequireAuth from '@auth/RequireAuth'

import ChurchDataProvider from '@data/ChurchDataProvider'

import StaffPage from '@pages/v2/Staff';

import Playlists from '@pages/v2/Playlists';
import PlaylistDetailsPage from '@pages/v2/Playlists/DetailsPage';
import ServicesPage from '@pages/v2/Services';
import ServicesLibraryPage from '@pages/v2/Services/LibraryPage';
import ServicesSeriesPage from '@pages/v2/Services/SeriesPage';
import SeriesServicesPage from '@pages/v2/Services/SeriesServicesPage';
import ServiceDetailsPage, { NewServicePage } from '@pages/v2/Services/DetailsPage';
import Launchpad from '@pages/v2/Launchpad';
import LaunchpadViewsPage from '@pages/v2/Launchpad/ViewsPage';
import LaunchpadTagsPage from '@pages/v2/Launchpad/TagsPage';
import LaunchpadDetailsPage from '@pages/v2/Launchpad/DetailsPage';
import Volunteering from '@pages/v2/Volunteering';
import VolunteeringTeamsPage from '@pages/v2/Volunteering/TeamsPage';
import VolunteeringTrainingPage from '@pages/v2/Volunteering/TrainingPage';
import TrainingModulePage from '@pages/v2/Volunteering/TrainingModulePage';
import VolunteerPage from '@pages/v2/Volunteering/VolunteerPage';
import VolunteerTeamPage from '@pages/v2/Volunteering/TeamPage';
import Welcome from '@pages/v2/Welcome';

import Connections from '@pages/Connections';
import Events from '@pages/Events';
import CreateEvent from '@pages/Events/CreateEvent';
import CreateEventDetails from '@pages/Events/CreateEvent/Details';
import CreateEventExternal from '@pages/Events/CreateEvent/Import';

import LoginPage from '@pages/LoginPage';

import './index.scss';
import '@styles/modal.scss'

import Modal from 'react-modal'
import ResetPasswordPage from '@pages/ResetPasswordPage';

// MARK: - V2

import Appv2 from './Appv2'
import ConnectionsRedirectPage from '@pages/Connections/Redirect';
import EventDetailsPage from '@pages/Events/DetailsPage';
import Settings from '@pages/v2/Settings';
import PeoplePage from '@pages/v2/People';
import PersonPage from '@pages/v2/People/PersonPage';

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <>
    <BrowserRouter>
      <AuthProvider>
        <ChurchDataProvider>
          <Routes>
            <Route element={<RequireAuth />}>
              <Route path="/" element={<Appv2 />}>
                <Route index element={<Welcome />} />
                <Route path="settings" element={<Settings />} />

                <Route path="home" element={<Welcome />} />
                <Route path="playlists" element={<Playlists />} />
                <Route path="playlists/:playlistID" element={<PlaylistDetailsPage />} />
                <Route path="services" element={<ServicesPage />}>
                  <Route index element={<ServicesLibraryPage />} />
                  <Route path="series" element={<ServicesSeriesPage />} />
                  <Route path="series/:seriesID" element={<SeriesServicesPage />} />
                </Route>
                <Route path="services/new" element={<NewServicePage />} />
                <Route path="services/:serviceID" element={<ServiceDetailsPage />} />
                <Route path="launchpad" element={<Launchpad />}>
                  <Route index element={<LaunchpadViewsPage />} />
                  {/* <Route path="tags" element={<LaunchpadTagsPage />} /> */}
                  <Route path=":launchpadID" element={<LaunchpadDetailsPage />} />
                </Route>
                <Route path="volunteering" element={<Volunteering />}>
                  <Route index element={<VolunteeringTeamsPage />} />
                  <Route path="training" element={<VolunteeringTrainingPage />} />
                  <Route path="training/:moduleID" element={<TrainingModulePage />} />
                  <Route path="teams/:teamID/people/:personID" element={<VolunteerPage />} />
                </Route>

                <Route path="people" element={<PeoplePage />} />
                <Route path="people/:personID" element={<PersonPage />} />

                <Route path="staff" element={<StaffPage />} />
                {/* Staff Members used to live here. */}
                <Route path="team" element={<Navigate to="/staff" replace />} />
                {/* A volunteer team's page; the sidebar maps it to Volunteering. */}
                <Route path="team/:teamID" element={<VolunteerTeamPage />} />

                {/* Where Sanctuary's OAuth callback lands; the old events-backend
                    path stays for links already in flight. */}
                <Route path="integrations/redirect" element={<ConnectionsRedirectPage />} />
                <Route path="connections/redirect" element={<ConnectionsRedirectPage />} />
                <Route path="connections" element={<Connections />} />

                <Route path="events" element={<Events />} />
                <Route path="events/create" element={<CreateEvent />} />
                <Route path="events/create/details" element={<CreateEventDetails />} />
                <Route path="events/create/import" element={<CreateEventExternal />} />
                <Route path="events/:eventID" element={<EventDetailsPage />} />

                <Route
                  path="*"
                  element={
                    <main style={{ padding: "1rem" }}>
                      <p>There's nothing here!</p>
                    </main>
                  }
                />
              </Route>
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Routes>
        </ChurchDataProvider>
      </AuthProvider>
    </BrowserRouter>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
